<template>
    <section
        class="o-flexible-module"
        :class="{ 'o-flexible-module--flush': settings.spacing == 'flush' }">
        <div class="grid-container" v-if="settings.showComponentTitle">
            <div class="grid-x grid-margin-x">
                <div class="small-12 cell">
                    <div class="utl-heading-beta">
                        {{ settings.componentTitle || 'CTA Block' }}
                    </div>
                </div>
            </div>
        </div>

        <div :class="`c-cta-block c-cta-block--${settings.theme}`">
            <div
                v-if="settings.disableCisilionLogos != true"
                class="c-cta-block__icons">
                <SvgoLogoRepeat />
            </div>

            <div class="grid-container">
                <div class="grid-x grid-margin-x">
                    <div class="small-12 medium-6 cell">
                        <h2 class="c-cta-block__title s-wp-cms" v-html="title" data-aos="fade-up"></h2>

                        <div class="c-cta-block__subtitle s-wp-cms" v-if="content" v-html="content"></div>
                    </div>

                    <div class="small-12 medium-5 medium-offset-1 cell">
                        <div class="c-cta-block__button-wrapper">
                            <NuxtLink
                                v-if="linkOptions == 'url'"
                                :to="$convertUrl(link.url)"
                                class="c-cta-block__button">
                                {{ link.title }}
                            </NuxtLink>

                            <NuxtLink
                                v-else-if="linkOptions == 'file'"
                                class="c-cta-block__button"
                                :to="file.mediaItemUrl"
                                :title="`Download ${file.title}`"
                                download>
                                {{ linkTitle }}
                            </NuxtLink>

                            <button
                                v-else
                                class="c-cta-block__button"
                                type="button"
                                @click="toggleMenuAndIsContactMenu">
                                {{ linkTitle }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
    import { useMainStore } from '~/store';

    const props = defineProps({
        title: {
            type: String,
            required: true
        },
        content: {
            type: String,
            required: false
        },
        linkOptions: {
            type: String,
            required: false
        },
        link: {
            type: Object,
            required: false
        },
        file: {
            type: Object,
            required: false,
        },
        hubspotFormId: {
            type: String,
            required: false
        },
        linkTitle: {
            type: String,
            required: false
        },
        settings: {
            disableCisilionLogos: {
                type: Boolean,
                required: false
            },
            theme: {
                type: String,
                required: true
            },
            showComponentTitle: {
                type: Boolean,
                required: true,
            },
            spacing: {
                type: String,
                required: true
            }
        }
    });

    const toggleMenuAndIsContactMenu = () => {
        toggleMenu();
        isContactMenu();
    }

    const isContactMenu = () => {
        useMainStore().openContact('global', props.hubspotFormId);
    }

    const toggleMenu = () => {
        useMainStore().toggleMenu();
    };
</script>
